import { useSelector } from 'react-redux'
import { selectGeoentities } from '../../store/geoentity/geoentity.selectors'

export const useGeoentityIndex = poi => {
  const pois = useSelector(selectGeoentities)
  return pois.findIndex(({ id }) => id === poi.id)
}
